<template>
  <v-btn
    :id="buttonId"
    density="default"
    variant="text"
    tile
    :append-icon="icon"
  >
    {{ buttonText }}
  </v-btn>
</template>

<script lang="ts" src="./PolteqButton.ts"></script>
